import { jsxs as S, jsx as c, Fragment as H } from "react/jsx-runtime";
import { useState as P, useRef as C, useCallback as de, useEffect as ae } from "react";
import u, { useTheme as me } from "styled-components";
import "@fcamna/shared-component-foundations";
import { u as ce } from "./useQuantum-50e8fd44.mjs";
import "./isClient-ec947a14.mjs";
import "./useSlots-a1aa6a84.mjs";
import { H as pe } from "./helperText-d9646f54.mjs";
import { Tooltip as O } from "./tooltip.js";
import "./index-65016bfa.mjs";
import "./_commonjsHelpers-92157f1b.mjs";
import "./icon.js";
import "@fcamna/shared-icons";
import "react-dom";
import "./usePopoverIndex-b3a93ecd.mjs";
import "./useWindowSize-88e90e04.mjs";
import "./getElementPosition-a8642645.mjs";
const z = ["ArrowDown", "ArrowUp", "ArrowLeft", "ArrowRight"], F = ["ArrowUp", "ArrowRight"], he = ["ArrowLeft", "ArrowDown"], ue = u.div`
  display: ${(e) => e.theme.components.slider.SliderContainer.display};
  flex-direction: ${(e) => e.theme.components.slider.SliderContainer.flexDirection};
  align-items: ${(e) => e.theme.components.slider.SliderContainer.alignItems};
  box-sizing: ${(e) => e.theme.components.slider.SliderContainer.boxSizing};
  justify-content: ${(e) => e.theme.components.slider.SliderContainer.justifyContent};
  width: ${(e) => e.theme.components.slider.SliderContainer.width};
  position: ${(e) => e.theme.components.slider.SliderContainer.position};
  .thumb,
  .thumb::-webkit-slider-thumb {
    -webkit-appearance: ${(e) => e.theme.components.slider.SliderContainer.thumbWebkitSliderThumb["-webkit-appearance"]};
    -webkit-tap-highlight-color: ${(e) => e.theme.components.slider.SliderContainer.thumbWebkitSliderThumb["-webkit-tap-highlight-color"]};
  }

  .thumb {
    pointer-events: ${(e) => e.theme.components.slider.SliderContainer.thumb.pointerEvents};
    position: ${(e) => e.theme.components.slider.SliderContainer.thumb.position};
    height: ${(e) => e.theme.components.slider.SliderContainer.thumb.height};
    width: ${(e) => e.theme.components.slider.SliderContainer.thumb.width};
    outline: ${(e) => e.theme.components.slider.SliderContainer.thumb.outline};
  }

  .thumb::-webkit-slider-thumb {
    background-color: ${(e) => e.theme.components.slider.SliderContainer.webkitSliderThumb.backgroundColor};
    border: ${(e) => e.theme.components.slider.SliderContainer.webkitSliderThumb.border};
    border-radius: ${(e) => e.theme.components.slider.SliderContainer.webkitSliderThumb.borderRadius};
    ${(e) => !e.isDisabled && `cursor: ${e.theme.components.slider.SliderContainer.webkitSliderThumb.cursor.default}`};
    height: ${(e) => e.theme.components.slider.SliderContainer.webkitSliderThumb.height};
    width: ${(e) => e.theme.components.slider.SliderContainer.webkitSliderThumb.width};
    margin-top: ${(e) => e.theme.components.slider.SliderContainer.webkitSliderThumb.marginTop};
    pointer-events: ${(e) => e.theme.components.slider.SliderContainer.webkitSliderThumb.pointerEvents};
    position: ${(e) => e.theme.components.slider.SliderContainer.webkitSliderThumb.position};

    &:hover {
      background-color: ${(e) => e.theme.components.slider.SliderContainer.webkitSliderThumb.hover.backgroundColor};
    }

    &:active {
      background-color: ${(e) => e.theme.components.slider.SliderContainer.webkitSliderThumb.active.backgroundColor};
    }
  }

  .thumb:focus-visible::-webkit-slider-thumb {
    outline: ${(e) => e.theme.components.slider.SliderContainer.thumbFocusVisibleWebkitSliderThumb.outline};
    outline-offset: ${(e) => e.theme.components.slider.SliderContainer.thumbFocusVisibleWebkitSliderThumb.outlineOffset};
  }

  input:disabled {
    &.thumb::-webkit-slider-thumb {
      background-color: ${(e) => e.theme.components.slider.SliderContainer.inputDisabled.thumbWebkitSliderThumb.backgroundColor};
      border: ${(e) => e.theme.components.slider.SliderContainer.inputDisabled.thumbWebkitSliderThumb.border};

      &:hover {
        background-color: ${(e) => e.theme.components.slider.SliderContainer.inputDisabled.thumbWebkitSliderThumb.hover.backgroundColor};
        pointer: ${(e) => e.theme.components.slider.SliderContainer.inputDisabled.thumbWebkitSliderThumb.hover.pointer};
      }
    }
  }

  .thumb::-moz-range-thumb {
    background-color: ${(e) => e.theme.components.slider.SliderContainer.thumbMozRangeThumb.backgroundColor};
    border: ${(e) => e.theme.components.slider.SliderContainer.thumbMozRangeThumb.border};
    border-radius: ${(e) => e.theme.components.slider.SliderContainer.thumbMozRangeThumb.borderRadius};
    cursor: ${(e) => e.theme.components.slider.SliderContainer.thumbMozRangeThumb.cursor};
    height: ${(e) => e.theme.components.slider.SliderContainer.thumbMozRangeThumb.height};
    width: ${(e) => e.theme.components.slider.SliderContainer.thumbMozRangeThumb.width};
    margin-top: ${(e) => e.theme.components.slider.SliderContainer.thumbMozRangeThumb.marginTop};
    pointer-events: ${(e) => e.theme.components.slider.SliderContainer.thumbMozRangeThumb.pointerEvents};
    position: ${(e) => e.theme.components.slider.SliderContainer.thumbMozRangeThumb.position};

    &:hover {
      background-color: ${(e) => e.theme.components.slider.SliderContainer.thumbMozRangeThumb.hover.backgroundColor};
    }

    &:active {
      background-color: ${(e) => e.theme.components.slider.SliderContainer.thumbMozRangeThumb.active.backgroundColor};
    }
  }
`, x = u.input`
  z-index: ${(e) => e.inputType === "first" ? e.theme.components.slider.SliderInput.zIndex.inputTypeFirst : e.theme.components.slider.SliderInput.zIndex.default};
  ${(e) => e.inputType === "first" && !Array.isArray(e.sliderValue) && `display: ${e.theme.components.slider.SliderInput.display}`};
  margin-left: ${(e) => e.inputType === "first" ? e.theme.components.slider.SliderInput.marginLeft.inputTypeFirst : e.theme.components.slider.SliderInput.marginLeft.default};
`, be = u.div`
  position: ${(e) => e.theme.components.slider.SliderWrapper.position};
  width: ${(e) => e.theme.components.slider.SliderWrapper.width};
  margin: ${(e) => e.theme.components.slider.SliderWrapper.margin};
  .tooltip-left {
    width: ${(e) => e.theme.components.slider.SliderWrapper.tooltipLeft.width};
    position: ${(e) => e.theme.components.slider.SliderWrapper.tooltipLeft.position};
    div[role='tooltip'] {
      /* Calculating tooltip left position */
      left: ${({ $minValue: e, $max: l, $min: s, $getPercent: f }) => {
  const y = f(e);
  return e < (s + l) / 2 ? `calc(1% + ${y}%)` : `calc(-1% + ${y}%)`;
}};
      bottom: ${(e) => e.theme.components.slider.SliderWrapper.tooltipLeft.divRoleTooltip.bottom};
    }
  }
  .tooltip-right {
    width: ${(e) => e.theme.components.slider.SliderWrapper.tooltipRight.width};
    position: ${(e) => e.theme.components.slider.SliderWrapper.tooltipRight.position};
    div[role='tooltip'] {
      left: ${({ $maxValue: e, $max: l, $min: s, $getPercent: f }) => {
  const y = f(e);
  return e < (s + l) / 2 ? `calc(1% + ${y}%)` : `calc(-1% + ${y}%)`;
}};
      bottom: ${(e) => e.theme.components.slider.SliderWrapper.tooltipRight.divRoleTooltip.bottom};
    }
  }
`, fe = u.div`
  background-color: ${(e) => e.isDisabled ? e.theme.components.slider.SliderTrack.backgroundColor.disabled : e.theme.components.slider.SliderTrack.backgroundColor.default};
  border-radius: ${(e) => e.theme.components.slider.SliderTrack.borderRadius};
  height: ${(e) => e.theme.components.slider.SliderTrack.height};
  width: ${(e) => e.theme.components.slider.SliderTrack.width};
  position: ${(e) => e.theme.components.slider.SliderTrack.position};
  z-index: ${(e) => e.theme.components.slider.SliderTrack.zIndex};
  width: ${(e) => e.theme.components.slider.SliderTrack.width};
`, ye = u.div`
  background-color: ${(e) => e.isDisabled ? e.theme.components.slider.SliderRange.backgroundColor.disabled : e.theme.components.slider.SliderRange.backgroundColor.default};
  border-radius: ${(e) => e.theme.components.slider.SliderRange.borderRadius};
  height: ${(e) => e.theme.components.slider.SliderRange.height};
  position: ${(e) => e.theme.components.slider.SliderRange.position};
  z-index: ${(e) => e.theme.components.slider.SliderRange.zIndex};
`, U = u.div`
  display: ${(e) => e.theme.components.slider.InputContainer.display};
  box-sizing: ${(e) => e.theme.components.slider.InputContainer.boxSizing};
  border-radius: ${(e) => e.theme.components.slider.InputContainer.borderRadius};
  border: ${(e) => e.theme.components.slider.InputContainer.border};
  background: ${(e) => e.isDisabled ? e.theme.components.slider.InputContainer.background.disabled : e.theme.components.slider.InputContainer.background.default};
  width: ${(e) => e.theme.components.slider.InputContainer.width};
  padding: ${(e) => e.theme.components.slider.InputContainer.padding};
  align-items: ${(e) => e.theme.components.slider.InputContainer.alignItems};
  justify-content: ${(e) => e.theme.components.slider.InputContainer.justifyContent};
  margin: ${(e) => e.theme.components.slider.InputContainer.margin};

  &.input-focus {
    border: ${(e) => e.theme.components.slider.InputContainer.inputFocus.border};
    margin: ${(e) => e.theme.components.slider.InputContainer.inputFocus.margin};
  }
`, ge = u.div`
  display: ${(e) => e.theme.components.slider.LabelWrapper.display};
  flex-direction: ${(e) => Array.isArray(e.value) && e.category === "inputField" ? e.theme.components.slider.LabelWrapper.flexDirection.categoryInputField : e.theme.components.slider.LabelWrapper.flexDirection.default};
  justify-content: ${(e) => e.theme.components.slider.LabelWrapper.justifyContent};
  width: ${(e) => e.theme.components.slider.LabelWrapper.width};
  margin-bottom: ${(e) => e.theme.components.slider.LabelWrapper.marginBottom};
  font-family: ${(e) => e.theme.components.slider.LabelWrapper.fontFamily};
  font-size: ${(e) => e.theme.components.slider.LabelWrapper.fontSize};
  font-style: ${(e) => e.theme.components.slider.LabelWrapper.fontStyle};
  font-weight: ${(e) => e.theme.components.slider.LabelWrapper.fontWeight};
  line-height: ${(e) => e.theme.components.slider.LabelWrapper.lineHeight};
  color: ${(e) => e.theme.components.slider.LabelWrapper.color};
  ${(e) => !Array.isArray(e.value) && `align-items: ${e.theme.components.slider.LabelWrapper.alignItems}`};
`, $e = u.div`
  display: ${(e) => e.theme.components.slider.ValueLabelWrapper.display};
  justify-content: ${(e) => e.theme.components.slider.ValueLabelWrapper.justifyContent};
  width: ${(e) => e.theme.components.slider.ValueLabelWrapper.width};
  font-family: ${(e) => e.theme.components.slider.ValueLabelWrapper.fontFamily};
  font-size: ${(e) => e.theme.components.slider.ValueLabelWrapper.fontSize};
  font-style: ${(e) => e.theme.components.slider.ValueLabelWrapper.fontStyle};
  font-weight: ${(e) => e.theme.components.slider.ValueLabelWrapper.fontWeight};
  line-height: ${(e) => e.theme.components.slider.ValueLabelWrapper.lineHeight};
  color: ${(e) => e.isDisabled ? e.theme.components.slider.ValueLabelWrapper.color.disabled : e.theme.components.slider.ValueLabelWrapper.color.default};
  ${(e) => !e.isDiscrete && `margin-top : ${e.theme.components.slider.ValueLabelWrapper.marginTop};`};
  padding: ${(e) => e.theme.components.slider.ValueLabelWrapper.padding};
`, q = u.div``, Se = u.div`
  display: ${(e) => e.theme.components.slider.InputWrapper.display};
  justify-content: ${(e) => e.theme.components.slider.InputWrapper.justifyContent};
`, Ae = u.span`
  width: ${(e) => e.theme.components.slider.DiscreteTick.width};
  height: ${(e) => e.theme.components.slider.DiscreteTick.height};
  background: ${(e) => e.isDisabled ? e.theme.components.slider.DiscreteTick.background.disabled : e.theme.components.slider.DiscreteTick.background.default};
  border-radius: ${(e) => e.theme.components.slider.DiscreteTick.borderRadius};
`, ke = u.div`
  display: ${(e) => e.theme.components.slider.TricksWrapper.display};
  justify-content: ${(e) => e.theme.components.slider.TricksWrapper.justifyContent};
  width: ${(e) => e.theme.components.slider.TricksWrapper.width};
  margin-bottom: ${(e) => e.theme.components.slider.TricksWrapper.marginBottom};
  margin-left: ${(e) => e.theme.components.slider.TricksWrapper.marginLeft};
  margin-top: ${(e) => e.theme.components.slider.TricksWrapper.marginTop};
`, we = u.div`
  ${(e) => Array.isArray(e.value) && e.category === "inputField" && `margin-bottom: ${e.theme.components.slider.Label.marginBottom};`};
  font-family: ${(e) => e.theme.components.slider.Label.fontFamily};
  font-size: ${(e) => e.theme.components.slider.Label.fontSize};
  font-style: ${(e) => e.theme.components.slider.Label.fontStyle};
  font-weight: ${(e) => e.theme.components.slider.Label.fontWeight};
  line-height: ${(e) => e.theme.components.slider.Label.lineHeight};
  color: ${(e) => e.theme.components.slider.Label.color};
`, Te = u.div`
  ${(e) => Array.isArray(e.value) && e.category === "inputField" && `margin-bottom: ${e.theme.components.slider.RangeLabel.marginBottom};`};
  font-family: ${(e) => e.theme.components.slider.RangeLabel.fontFamily};
  font-size: ${(e) => e.theme.components.slider.RangeLabel.fontSize};
  font-style: ${(e) => e.theme.components.slider.RangeLabel.fontStyle};
  font-weight: ${(e) => e.theme.components.slider.RangeLabel.fontWeight};
  line-height: ${(e) => e.theme.components.slider.RangeLabel.lineHeight};
  color: ${(e) => e.isDisabled ? e.theme.components.slider.RangeLabel.color.disabled : e.theme.components.slider.RangeLabel.color.default};
`, Q = u.input`
  width: ${(e) => e.theme.components.slider.BaseTextInput.width};
  letter-spacing: ${(e) => e.theme.components.slider.BaseTextInput.letterSpacing};
  font-size: ${(e) => e.theme.components.slider.BaseTextInput.fontSize};
  background-color: ${(e) => e.theme.components.slider.BaseTextInput.backgroundColor};
  color: ${(e) => e.disabled ? e.theme.components.slider.BaseTextInput.color.disabled : e.theme.components.slider.BaseTextInput.color.default};
  border-style: ${(e) => e.theme.components.slider.BaseTextInput.borderStyle};
  outline-style: ${(e) => e.theme.components.slider.BaseTextInput.outlineStyle};
  font-style: ${(e) => e.theme.components.slider.BaseTextInput.fontStyle};
  font-weight: ${(e) => e.theme.components.slider.BaseTextInput.fontWeight};
  line-height: ${(e) => e.theme.components.slider.BaseTextInput.lineHeight};
`, Ve = u.div`
  display: ${(e) => e.theme.components.slider.StyledSlider.display};
  flex-direction: ${(e) => e.theme.components.slider.StyledSlider.flexDirection};
  gap: ${(e) => e.theme.components.slider.StyledSlider.gap};
`;
function Ue({
  min: e = 0,
  max: l = 100,
  isDiscrete: s = !1,
  steps: f = 10,
  category: y = "tooltip",
  label: j,
  onChange: d,
  isDisabled: h = !1,
  value: r,
  isRequired: B = !1,
  showRequiredIndicator: _ = B,
  helperTextProp: w,
  inputState: G,
  valueLabel: W,
  minLabel: J = e.toString(),
  maxLabel: X = l.toString()
}) {
  const Y = ce({ label: "Slider" }), a = (t) => {
    const n = (l - e) / f;
    let i = e;
    if (t < e)
      return e;
    if (t > l)
      return l;
    for (let o = 0; o < f; o++) {
      const m = i;
      if (i = i + n, t <= i)
        return t < m + n / 2 ? m : i;
    }
    return i;
  }, Z = Array.isArray(r) ? s ? a(r[0]) : r[0] : 0, D = Array.isArray(r) ? s ? a(r[1]) : r[1] : r, [g, $] = P(Z), [p, b] = P(D), L = C(null), I = C(null), T = C(null), A = C(null), k = C(null), v = me(), ee = Array.from(Array(f + 1), (t, n) => n + 1), V = de((t) => Math.round((t - e) / (l - e) * 100), [e, l]), te = (t) => {
    t[1] > l && d(null, [t[0], l]), t[0] < e && d(null, [e, t[1]]), t[1] < t[0] && d(null, [t[0], t[0]]), t[0] > t[1] && d(null, [t[1], t[1]]);
  }, re = (t) => {
    if (I.current && Array.isArray(t) && t[0] >= 0) {
      const n = Array.isArray(t) ? s ? a(t[0]) : t[0] : e, i = V(n), o = V(+I.current.value);
      T.current && (T.current.style.left = `${i}%`, T.current.style.width = `${o - i}%`, $(s ? a(t[0]) : t[0]));
    }
  }, ne = (t) => {
    if (L.current && (Array.isArray(t) ? t[1] >= 0 : t >= 0)) {
      const n = V(+L.current.value), i = Array.isArray(t) ? s ? a(t[1]) : t[1] : t, o = V(i);
      T.current && (T.current.style.width = `${o - n}%`, Array.isArray(t) ? b(t[1]) : b(t));
    }
  };
  ae(() => {
    !Array.isArray(r) && (r < e || r > l) ? (r < e && d(null, e), r > l && d(null, l)) : Array.isArray(r) && (r[1] < r[0] || r[0] > r[1] || r[0] < e || r[1] > l) ? te(r) : (re(r), ne(r));
  }, [r, V, e, l, s, f]);
  const ie = (t) => {
    if (t.target.value === "-" || t.target.value === "") {
      const n = t.target.value;
      b(n);
    } else
      isNaN(+t.target.value) || b(+t.target.value);
  }, oe = (t) => {
    if (t.target.value === "-" || t.target.value === "") {
      const n = t.target.value;
      $(n);
    } else
      isNaN(+t.target.value) || $(+t.target.value);
  }, E = (t) => {
    if (g === "" || g === "-")
      $(Array.isArray(r) ? r[0] : e);
    else if (typeof g == "number" && Array.isArray(r))
      if (g > r[1] || g < e) {
        const n = g > r[1] ? r[1] : g < e ? e : r[0], i = [...r];
        i[0] = n, d(t, i), $(n);
      } else if (s) {
        const n = a(g);
        d(t, [n, r[1]]), $(a(r[0]));
      } else
        d(t, [g, r[1]]);
  }, N = (t) => {
    if (p === "" || p === "-")
      b(Array.isArray(r) ? r[1] : r);
    else if (typeof p == "number" && Array.isArray(r))
      if (p < r[0] || p > l) {
        const n = p < r[0] ? r[0] : l;
        d(t, [r[0], n]), b(n);
      } else
        s ? (d(t, [r[0], a(p)]), b(a(p))) : d(t, [r[0], p]);
    else if (typeof p == "number" && !Array.isArray(r))
      if (p < e || p > l) {
        const n = p < e ? e : l;
        d(t, n), b(n);
      } else
        s ? (d(t, a(p)), b(a(p))) : d(t, p);
  }, K = (t) => !(!isNaN(t) && Math.abs(t % 1) === 0 || t === "-"), R = (t, n, i, o) => {
    let m = o === "min" ? n[0] : n[1];
    if (m = F.includes(t.code) ? m + i : m - i, o === "min") {
      if (n[0] === n[1] && F.includes(t.code))
        return;
      d(t, [m, n[1]]), $(m);
    } else {
      if (n[0] === n[1] && he.includes(t.code))
        return;
      d(t, [n[0], m]), b(m);
    }
  }, M = (t, n, i) => {
    let o = n;
    o = F.includes(t.code) ? o + i : o - i, d(t, o), b(o);
  }, se = (t, n, i) => {
    if (s) {
      const o = a(t);
      o !== i[1] && d(n, [i[0], o]), b(o);
    } else
      d(n, [i[0], t]), b(t);
  }, le = (t, n, i) => {
    if (s) {
      const o = a(t);
      o !== i && d(n, o), b(o);
    } else
      d(n, t), b(t);
  };
  return /* @__PURE__ */ S(Ve, { ...Y, children: [
    /* @__PURE__ */ S(ue, { isDisabled: h, children: [
      /* @__PURE__ */ S(
        ge,
        {
          value: r,
          category: y,
          children: [
            j && /* @__PURE__ */ S(
              we,
              {
                value: r,
                category: y,
                children: [
                  j,
                  _ && /* @__PURE__ */ S(
                    "span",
                    {
                      "aria-hidden": "true",
                      style: {
                        color: v.components.slider.LabelRequiredIndicatorColor
                      },
                      children: [
                        " ",
                        "*"
                      ]
                    }
                  )
                ]
              }
            ),
            y === "inputField" && /* @__PURE__ */ S(Se, { children: [
              Array.isArray(r) && /* @__PURE__ */ c(U, { isDisabled: h, children: /* @__PURE__ */ c(
                Q,
                {
                  id: "min-value",
                  type: "text",
                  "aria-required": B,
                  ref: A,
                  disabled: h,
                  value: g,
                  onChange: oe,
                  onKeyPress: (t) => {
                    K(t.key) && t.preventDefault(), (t.code === "Escape" || t.code === "Enter") && E(t);
                  },
                  onBlur: (t) => E(t)
                }
              ) }),
              /* @__PURE__ */ c(U, { isDisabled: h, children: /* @__PURE__ */ c(
                Q,
                {
                  id: "max-value",
                  type: "text",
                  "aria-required": B,
                  ref: k,
                  disabled: h,
                  value: p,
                  onChange: ie,
                  onKeyPress: (t) => {
                    K(t.key) && t.preventDefault(), (t.code === "Escape" || t.code === "Enter") && N(t);
                  },
                  onBlur: (t) => N(t)
                }
              ) })
            ] }),
            y === "tooltip" && /* @__PURE__ */ c(
              Te,
              {
                value: r,
                category: y,
                isDisabled: h,
                children: W != null && W.trim().length ? W : Array.isArray(r) ? s ? `${a(r[0])} - ${a(r[1])}` : `${r[0]} - ${r[1]}` : r
              }
            )
          ]
        }
      ),
      /* @__PURE__ */ S(
        be,
        {
          $minValue: Array.isArray(r) ? s ? a(r[0]) : r[0] : e,
          $maxValue: Array.isArray(r) ? s ? a(r[1]) : r[1] : r,
          $min: e,
          $max: l,
          $getPercent: V,
          children: [
            y === "tooltip" ? /* @__PURE__ */ S(H, { children: [
              /* @__PURE__ */ c(
                O,
                {
                  placement: "top",
                  title: Array.isArray(r) ? s ? a(r[0]).toString() : r[0].toString() : e.toString(),
                  className: "tooltip-left",
                  isDisabled: h,
                  children: /* @__PURE__ */ c(
                    x,
                    {
                      type: "range",
                      min: e,
                      max: l,
                      disabled: h,
                      value: Array.isArray(r) ? s ? a(r[0]) : r[0] : e,
                      ref: L,
                      onChange: (t) => {
                        const n = Array.isArray(r) ? r[1] : r || 100, i = Math.min(+t.target.value, n - 1);
                        if (Array.isArray(r))
                          if (s) {
                            const o = a(i);
                            o !== r[0] && d(t, [o, r[1]]);
                          } else
                            d(t, [i, r[1]]);
                        t.target.value = r.toString();
                      },
                      onKeyDown: (t) => {
                        if (z.includes(t.code) && s) {
                          const n = (l - e) / f;
                          Array.isArray(r) ? R(t, r, n, "min") : M(t, r, n), t.preventDefault();
                        }
                      },
                      inputType: "first",
                      className: "thumb",
                      sliderValue: r
                    }
                  )
                }
              ),
              /* @__PURE__ */ c(
                O,
                {
                  placement: "top",
                  title: Array.isArray(r) ? s ? a(r[1]).toString() : r[1].toString() : r.toString(),
                  className: "tooltip-right",
                  isDisabled: h,
                  children: /* @__PURE__ */ c(
                    x,
                    {
                      type: "range",
                      min: e,
                      max: l,
                      disabled: h,
                      value: Array.isArray(r) ? s ? a(r[1]) : r[1] : r,
                      ref: I,
                      onChange: (t) => {
                        const n = Array.isArray(r) ? r[0] : e || 0, i = Array.isArray(r) ? n + 1 : n, o = Math.max(+t.target.value, i);
                        if (Array.isArray(r))
                          if (s) {
                            const m = a(o);
                            m !== r[1] && d(t, [r[0], m]);
                          } else
                            d(t, [r[0], o]);
                        else if (s) {
                          const m = a(o);
                          m !== r && d(t, m);
                        } else
                          d(t, o);
                        t.target.value = r.toString();
                      },
                      onKeyDown: (t) => {
                        if (z.includes(t.code) && s) {
                          const n = (l - e) / f;
                          Array.isArray(r) ? R(t, r, n, "max") : M(t, r, n), t.preventDefault();
                        }
                      },
                      "aria-label": "max-input",
                      inputType: "second",
                      className: "thumb",
                      sliderValue: r
                    }
                  )
                }
              )
            ] }) : /* @__PURE__ */ S(H, { children: [
              /* @__PURE__ */ c(
                x,
                {
                  type: "range",
                  min: e,
                  max: l,
                  disabled: h,
                  value: Array.isArray(r) ? s ? a(r[0]) : r[0] : e,
                  ref: L,
                  onChange: (t) => {
                    var o;
                    A.current && ((o = A.current.parentElement) == null || o.classList.add("input-focus"));
                    const n = Array.isArray(r) ? r[1] : r || 100, i = Math.min(+t.target.value, n - 1);
                    if (Array.isArray(r))
                      if (s) {
                        const m = a(i);
                        m !== r[0] && d(t, [m, r[1]]), $(m);
                      } else
                        d(t, [i, r[1]]), $(i);
                    t.target.value = r.toString();
                  },
                  onMouseOut: () => {
                    var t, n;
                    k.current && A.current && ((t = k.current.parentElement) == null || t.classList.remove("input-focus"), (n = A.current.parentElement) == null || n.classList.remove("input-focus"));
                  },
                  onKeyDown: (t) => {
                    if (z.includes(t.code) && s) {
                      const n = (l - e) / f;
                      Array.isArray(r) ? R(t, r, n, "min") : M(t, r, n), t.preventDefault();
                    }
                  },
                  inputType: "first",
                  className: "thumb",
                  sliderValue: r
                }
              ),
              /* @__PURE__ */ c(
                x,
                {
                  type: "range",
                  min: e,
                  max: l,
                  disabled: h,
                  value: Array.isArray(r) ? s ? a(r[1]) : r[1] : r,
                  ref: I,
                  onChange: (t) => {
                    var m;
                    k.current && ((m = k.current.parentElement) == null || m.classList.add("input-focus"));
                    const n = Array.isArray(r) ? r[0] : e || 0, i = Array.isArray(r) ? n + 1 : n, o = Math.max(+t.target.value, i);
                    Array.isArray(r) ? se(o, t, r) : le(o, t, r), t.target.value = r.toString();
                  },
                  onMouseOut: () => {
                    var t, n, i, o;
                    (k.current && A.current || !Array.isArray(r)) && ((n = (t = k == null ? void 0 : k.current) == null ? void 0 : t.parentElement) == null || n.classList.remove("input-focus"), (o = (i = A == null ? void 0 : A.current) == null ? void 0 : i.parentElement) == null || o.classList.remove("input-focus"));
                  },
                  onKeyDown: (t) => {
                    if (z.includes(t.code) && s) {
                      const n = (l - e) / f;
                      Array.isArray(r) ? R(t, r, n, "max") : M(t, r, n), t.preventDefault();
                    }
                  },
                  "aria-label": "max-input",
                  inputType: "second",
                  className: "thumb",
                  sliderValue: r
                }
              )
            ] }),
            /* @__PURE__ */ c(fe, { isDisabled: h }),
            /* @__PURE__ */ c(
              ye,
              {
                isDisabled: h,
                ref: T
              }
            )
          ]
        }
      ),
      s && /* @__PURE__ */ c(ke, { children: ee.map(
        (t, n) => t && /* @__PURE__ */ c(
          Ae,
          {
            isDisabled: h
          },
          n
        )
      ) }),
      /* @__PURE__ */ S(
        $e,
        {
          isDiscrete: s,
          isDisabled: h,
          children: [
            /* @__PURE__ */ c(q, { children: J }),
            /* @__PURE__ */ c(q, { children: X })
          ]
        }
      )
    ] }),
    /* @__PURE__ */ c(
      pe,
      {
        defaultProp: w == null ? void 0 : w.defaultProp,
        secondaryProp: { ...w == null ? void 0 : w.secondaryProp, state: G }
      }
    )
  ] });
}
export {
  Ue as Slider
};
